// This is a placeholder until we get a better solution
var QuestionFeedback = require("components/writing/questions/QuestionFeedback");

require('users/students/onboarding/component_demonstrator.scss');

class ComponentDemonstrator extends React.Component {
	constructor(props) {
		super();
		this.state = {showFeedback: false, slide:false}
	}
	renderFeedback(message) {
		return (
			<QuestionFeedback feedbackItems={ message } />
		);
	}
	trigger() {
		this.setState({showFeedback: true, slide: true})
	}
	getFeedback() {
		switch(this.props.component) {
			case "warmup_question_1":
				return this.renderFeedback(["Congratulation on starting your first quiz! First tell me about the book you are reading. Is it about a true story or something imaginary?"])
			break;
			case "warmup_question_2":
				return this.renderFeedback(["Next, answer these few questions. Remember to keep it short!"])
			break;
		}
		return null;
	}
	getDemoStyle() {
		switch(this.props.component) {
			case "warmup_question_1":
				return {width: '60%'}
			break;
			case "warmup_question_2":
				return {width: '75%'}
			break;
		}
		return {};
	}
	getFeedbackStyle() {
		switch(this.props.component) {
			case "warmup_question_1":
				return {width: '40%'}
			break;
			case "warmup_question_2":
				return {width: '25%'}
			break;
		}
		return null;
	}
	render() { 
		if (this.state.showFeedback) {
			var feedback = this.getFeedback()
		}
		if (this.state.slide) {
			var slideClass = ""
		}
		return (
			<div className="ComponentDemonstrator">
				<div className="demo" style={this.getDemoStyle()}>
					{ this.props.children }
				</div>
				<div className="questionFeedbackBox" style={this.getFeedbackStyle()}>
					{ feedback }
				</div>
			</div>
		)
	}
	componentDidUpdate(prevProps) {
		if (prevProps.component != this.props.component) {
			this.setState({showFeedback: false, slide: false})
			setTimeout(this.trigger.bind(this), 1000)
		}
	}
	componentDidMount() {
		setTimeout(this.trigger.bind(this), 1000)
	}
}
module.exports = ComponentDemonstrator;



// WEBPACK FOOTER //
// ./modules/components/users/students/onboarding/ComponentDemonstrator.js